(function () {
  // Event delegation for all swatch buttons
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".swatch");
    if (!btn) return;

    const container = btn.closest("[data-color-swatches]");
    if (!container) return;

    // visual state
    container.querySelectorAll(".swatch.is-active").forEach(function (el) {
      el.classList.remove("is-active");
      el.setAttribute("aria-pressed", "false");
    });
    btn.classList.add("is-active");
    btn.setAttribute("aria-pressed", "true");

    // sync to the hidden select that Sense's variant-selects listens to
    const select = container.querySelector(".swatch-sync-select");
    if (select) {
      select.value = btn.getAttribute("data-swatch-value");

      // IMPORTANT: fire a real change event so variant-selects updates:
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
})();
